import styled, { css } from 'styled-components';
export const DateFieldWrapper = styled.div `
  ${({ theme, $state, $isFocused }) => css `
    ${theme.getFontStyle('samsung-400-14')};
    border: 1px solid
      ${$isFocused
    ? theme.getColor('black', 'default')
    : $state === 'error'
        ? theme.getColor('error', 'default')
        : theme.getColor('gray', '05')};
    border-radius: 8px;
    background-color: ${theme.getColor('white')};
    color: ${theme.getColor('black')};
    &::placeholder {
      color: ${theme.getColor('gray', '03')};
    }
  `};
  display: flex;
  align-items: center;
  height: 4rem;
  padding: 0 1.2rem;
`;
export const DateInput = styled.input `
  flex: 1;
  height: 100%;

  /* 브라우저별 기본 스타일 제거 */
  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }

  /* date input의 일부 브라우저별 스타일 통일 */
  &::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
`;
//# sourceMappingURL=DateField.styles.js.map